import AppAccessControl from "@/layouts/auth/components/AppAccessControl";
import PostCreatorAccessRequired from "@/layouts/auth/components/PostCreatorAccessRequired";
import TypeOfAccountRequired from "@/layouts/auth/components/TypeOfAccountRequired";
import UserAccountRequired from "@/layouts/auth/components/UserAccountRequired";
import AppNavigation from "@/layouts/navigation/components/AppNavigation";
import Artwork from "@/pages/artwork";
import PurchaseProcess from "@/pages/artwork/purchase/purchase-process";
import SuarteWorld from "@/pages/home/suarteworld";
import SellInStoreTermsPage from "@/pages/information/sell-in-store-terms";
import MyCollection from "@/pages/my-collection";
import SuarteNewspaper from "@/pages/newspaper";
import NewspaperArtGames from "@/pages/newspaper/art-games";
import ChromaticMusicGame from "@/pages/newspaper/art-games/chromatic-music";
import ColorMixGame from "@/pages/newspaper/art-games/color-mix";
import Ippitsugaki from "@/pages/newspaper/art-games/ippitsugaki";
import KaleidoscopeGame from "@/pages/newspaper/art-games/kaleidoscope";
import ArtGamesRadioProvider from "@/pages/newspaper/art-games/radio/ArtGamesRadioProvider";
import NewspaperCategoryPage from "@/pages/newspaper/NewspaperCategoryPage";
import NewspaperCategoryPageTWO from "@/pages/newspaper/NewspaperCategoryPageTWO";
import Notifications from "@/pages/notifications";
import PaymentFailed from "@/pages/payment-failed";
import AddArticle from "@/pages/profile/add-article";
import AddArtwork from "@/pages/profile/add-artwork";
import AddPost from "@/pages/profile/add-post";
import ProfileAiSetup from "@/pages/profile/ai-setup";
import ProfileArtistHelp from "@/pages/profile/artist-help";
import ProfileArtistHelpArtworksPage from "@/pages/profile/artist-help/artworks";
import ProfileArtistHelpLimitedEditionsPage from "@/pages/profile/artist-help/limited-editions";
import ProfileArtistHelpPaymentCommissionsPage from "@/pages/profile/artist-help/payment-commissions";
import ProfileArtistHelpProfilePage from "@/pages/profile/artist-help/profile";
import ProfileArtistHelpPurchaseOriginalsPage from "@/pages/profile/artist-help/purchase-originals";
import ProfileArtistHelpSuarteFeaturesPage from "@/pages/profile/artist-help/suarte-features";
import ProfileArtistHelpSubscriptionsStudioPage from "@/pages/profile/artist-help/subscriptions-studio";
import ProfileArtistHelpSupportSubscriptionsPage from "@/pages/profile/artist-help/support-subscriptions";
import Artlist from "@/pages/profile/artlist";
import ArtworkRequest from "@/pages/profile/artwork-request";
import ChannelChat from "@/pages/profile/channels/ChannelChat";
import ChannelInfo from "@/pages/profile/channels/ChannelInfo";
import ChannelLayout from "@/pages/profile/channels/ChannelLayout";
import ChannelsDiscoverPage from "@/pages/profile/channels/ChannelsDiscoverPage";
import ChannelSettingsView from "@/pages/profile/channels/ChannelSettingsView";
import SubscriptionPreview from "@/pages/profile/channels/SubscriptionPreview";
import DirectMessagesChat from "@/pages/profile/chat-dm/DirectMessagesChat";
import DirectMessagesLayout from "@/pages/profile/chat-dm/DirectMessagesLayout";
import ProfileCollectorHelp from "@/pages/profile/collector-help";
import ProfileCollectorHelpArtistsAndGalleriesPage from "@/pages/profile/collector-help/artists-and-galleries";
import ProfileCollectorHelpFindAndSelectPage from "@/pages/profile/collector-help/find-and-select";
import ProfileCollectorHelpGetStartedPage from "@/pages/profile/collector-help/get-started";
import ProfileCollectorHelpLimitedEditionsPage from "@/pages/profile/collector-help/limited-editions";
import ProfileCollectorHelpPurchaseOriginalsPage from "@/pages/profile/collector-help/purchase-originals";
import ProfileCollectorHelpShippingAndReturnsPage from "@/pages/profile/collector-help/shipping-and-returns";
import ProfileCollectorHelpSupportSubscriptionsPage from "@/pages/profile/collector-help/support-subscriptions";
import EditArtwork from "@/pages/profile/edit-artwork";
import ProfileGalleryHelp from "@/pages/profile/gallery-help";
import ProfileGalleryHelpAccountPage from "@/pages/profile/gallery-help/account";
import ProfileGalleryHelpAdminModePage from "@/pages/profile/gallery-help/admin-mode";
import ProfileGalleryHelpArtistsPage from "@/pages/profile/gallery-help/artists";
import ProfileGalleryHelpCommissionsPage from "@/pages/profile/gallery-help/commissions";
import ProfileGalleryHelpLimitedEditionsPage from "@/pages/profile/gallery-help/limited-editions";
import ProfileGalleryHelpManageInventoryPage from "@/pages/profile/gallery-help/manage-inventory";
import ProfileGalleryHelpPaymentAndInvoicesPage from "@/pages/profile/gallery-help/payment-and-invoices";
import ProfileGalleryHelpRoyaltiesPage from "@/pages/profile/gallery-help/royalties";
import ProfileGalleryHelpSellAndShipPage from "@/pages/profile/gallery-help/sell-and-ship";
import ProfileGalleryHelpSuarteFeaturesPage from "@/pages/profile/gallery-help/suarte-features";
import ProfileGalleryHelpSubscriptionsVipStudioPage from "@/pages/profile/gallery-help/subscriptions-vip-studio";
import ProfileGalleryHelpUploadArtworksPage from "@/pages/profile/gallery-help/upload-artworks";
import ProfileOffers from "@/pages/profile/offers";
import ProfileSubscriptions from "@/pages/profile/payments";
import PlayArtlist from "@/pages/profile/play-artlist";
import SuarteRoad from "@/pages/suarte-road";
import SuarteRoadReward from "@/pages/suarte-road/suarte-road-reward";
import ArticleWrapper from "@/shared-components/forms/add-board-content/add-article/ArticleWrapper";
import EditArticle from "@/shared-components/forms/add-board-content/add-article/edit-article";
import ArticlePreview from '@/shared-components/forms/add-board-content/add-article/preview/ArticlePreview';
import EditPost from "@/shared-components/forms/add-board-content/add-post/edit-post";
import Post from "@/shared-components/forms/add-board-content/add-post/post";

import GalleryProfileOptions from "./application-routes/gallery_profile_options.routes";
import HomeRoutes from "./application-routes/home.routes";
import OrderRoutes from "./application-routes/order.routes";
import SearchRoutes from "./application-routes/search.routes";
import UserActivityRoutes from "./application-routes/user_activity.routes";
import { ExternalProfileRoutes, InternalProfileRoutes } from "./application-routes/user_profile.routes";
import UserSettingsRoutes from "./application-routes/user_settings.routes";

/**
  * These are the routes that are inside of the app. We will have routes that anyone can enter (account or guest) and we will have protected routes (only people with accounts or certain type of accounts will be able to enter).
  * Internally, a guest is not an account, it's just a logical abstraction. Everyone without a session will be treated as a guest.
  * 
  * Admins are not allowed to enter the app routes either. They will be redirected to /admin routes.
  */
const AppRoutes = [
  {
    element: <ArtGamesRadioProvider><AppAccessControl/></ArtGamesRadioProvider>,
    children: [
      {
        element: <AppNavigation/>,
        children: [
          ...ExternalProfileRoutes,
          ...HomeRoutes,
          ...SearchRoutes,
          // first the specific, then the index:
          { path: "/newspaper/pq/:collection_url", element: <NewspaperCategoryPageTWO/> },
          { path: "/newspaper/art-games", element: <NewspaperArtGames/>, handle: { artGamesRadio: true } },
          { path: "/newspaper/:collection_url", element: <NewspaperCategoryPage/> },
          { path: "/newspaper",              element: <SuarteNewspaper/> },
          { path: "/notifications", element: <Notifications/> },
          { path: "/payment-failed", element: <PaymentFailed/> },
          {
            element: <UserAccountRequired/>,
            children: [
              ...InternalProfileRoutes,
              { path: "/payments-profile", element: <ProfileSubscriptions /> },
              { path: "/channels/discover", element: <ChannelsDiscoverPage /> },
              {
                path: "/channels",
                element: <ChannelLayout />,
                children: [
                  { index: true, element: <p style={{ marginTop: '200px' }}>Select a VIP conversation to enter</p> },
                ]
              },
              {
                path: "/channel",
                element: <ChannelLayout />,
                children: [
                  { index: true, element: <p style={{ marginTop: '200px' }}>Select a VIP conversation to enter</p> },
                  { path: ":ownerUsername/:channelId", element: <ChannelChat /> },
                  { path: ":ownerUsername/:channelId/info", element: <ChannelInfo /> },
                  { path: ":ownerUsername/:channelId/join", element: <SubscriptionPreview /> }
                ]
              },
              {
                path: "/chat/gallery/:user_username",
                children: [
                  { index: true, element: <ChannelSettingsView /> },
                  { path: "preferences", element: <ChannelSettingsView /> },
                ]
              },
              // Keep only direct messages under /chat/dm
              {
                path: "/chat/dm",
                element: <DirectMessagesLayout />,
                children: [
                  { index: true, element: <p style={{ marginTop: '200px' }}>Select a private chat to enter the conversation</p> },
                  { path: ":user_username/:conversationId?", element: <DirectMessagesChat /> }
                ]
              },     
            ]
          }
        ]
      },
      { path: "/artlist/:artlistId", element: <Artlist/> },
      { path: "/artlist/play", element: <PlayArtlist/> }, 
      { path: "/post/:postSlug/:postId", element: <Post/> },
      { path: "/post/:postId", element: <Post/> },
      { path: "/article/:articleSlug/:articleId", element: <ArticleWrapper/> },
      { path: "/article/:articleId", element: <ArticleWrapper/> },
      { path: '/artwork/:slug', element: <Artwork/> },
      { path: '/newspaper/art-games/color-mix', element: <ColorMixGame/>, handle: { artGamesRadio: true } },
      { path: "/newspaper/art-games/ippitsugaki", element: <Ippitsugaki/>, handle: { artGamesRadio: true } },
      { path: '/newspaper/art-games/kaleidoscope', element: <KaleidoscopeGame/>, handle: { artGamesRadio: true } },
      { path: '/newspaper/art-games/chromatic-music', element: <ChromaticMusicGame/> },
      { path: '/artwork/purchase', element: <PurchaseProcess/> },
      { path: "/suarteworld", element: <SuarteWorld/> },
      { path: '/suarteworld/artwork/:slug', element: <Artwork/> },
      {
        element: <UserAccountRequired/>, /** This is for protected routes that do not have the app navigation layout */
        children: [
          ...UserSettingsRoutes,
          ...UserActivityRoutes,
          ...OrderRoutes,
          {
            element: <TypeOfAccountRequired allowedTypes={["gallery"]}/>,
            children: [
              ...GalleryProfileOptions,
              { path: "/artwork-request", element: <ArtworkRequest/> },
              { path: "/profile/gallery-help", element: <ProfileGalleryHelp/> },
              { path: "/profile/gallery-help/account", element: <ProfileGalleryHelpAccountPage/> },
              { path: "/profile/gallery-help/admin-mode", element: <ProfileGalleryHelpAdminModePage/> },
              { path: "/profile/gallery-help/artists", element: <ProfileGalleryHelpArtistsPage/> },
              { path: "/profile/gallery-help/commissions", element: <ProfileGalleryHelpCommissionsPage/> },
              { path: "/profile/gallery-help/limited-editions", element: <ProfileGalleryHelpLimitedEditionsPage/> },
              { path: "/profile/gallery-help/manage-inventory", element: <ProfileGalleryHelpManageInventoryPage/> },
              { path: "/profile/gallery-help/payment-and-invoices", element: <ProfileGalleryHelpPaymentAndInvoicesPage/> },
              { path: "/profile/gallery-help/royalties", element: <ProfileGalleryHelpRoyaltiesPage/> },
              { path: "/profile/gallery-help/sell-and-ship", element: <ProfileGalleryHelpSellAndShipPage/> },
              { path: "/profile/gallery-help/subscriptions-vip-studio", element: <ProfileGalleryHelpSubscriptionsVipStudioPage/> },
              { path: "/profile/gallery-help/suarte-features", element: <ProfileGalleryHelpSuarteFeaturesPage/> },
              { path: "/profile/gallery-help/upload-artworks", element: <ProfileGalleryHelpUploadArtworksPage/> },
              { path: "/sell-in-store-terms", element: <SellInStoreTermsPage/> },
            ]
          },
          {
            element: <TypeOfAccountRequired allowedTypes={["gallery", "artist", "gallery_artist"]}/>,
            children: [
              { path: "/profile/add-artwork", element: <AddArtwork/> },
              { path: "/profile/ai-setup", element: <ProfileAiSetup/> },
            ]
          },
          {
            element: <TypeOfAccountRequired allowedTypes={["artist"]}/>,
            children: [
              { path: "/profile/artist-help", element: <ProfileArtistHelp/> },
              { path: "/profile/artist-help/artworks", element: <ProfileArtistHelpArtworksPage/> },
              { path: "/profile/artist-help/limited-editions", element: <ProfileArtistHelpLimitedEditionsPage/> },
              { path: "/profile/artist-help/payment-commissions", element: <ProfileArtistHelpPaymentCommissionsPage/> },
              { path: "/profile/artist-help/purchase-originals", element: <ProfileArtistHelpPurchaseOriginalsPage/> },
              { path: "/profile/artist-help/profile", element: <ProfileArtistHelpProfilePage/> },
              { path: "/profile/artist-help/suarte-features", element: <ProfileArtistHelpSuarteFeaturesPage/> },
              { path: "/profile/artist-help/subscriptions-studio", element: <ProfileArtistHelpSubscriptionsStudioPage/> },
              { path: "/profile/artist-help/support-subscriptions", element: <ProfileArtistHelpSupportSubscriptionsPage/> },
            ]
          },
          {
            element: <TypeOfAccountRequired allowedTypes={["collector"]}/>,
            children: [
              { path: "/profile/collector-help", element: <ProfileCollectorHelp/> },
              { path: "/profile/collector-help/artists-and-galleries", element: <ProfileCollectorHelpArtistsAndGalleriesPage/> },
              { path: "/profile/collector-help/find-and-select", element: <ProfileCollectorHelpFindAndSelectPage/> },
              { path: "/profile/collector-help/get-started", element: <ProfileCollectorHelpGetStartedPage/> },
              { path: "/profile/collector-help/limited-editions", element: <ProfileCollectorHelpLimitedEditionsPage/> },
              { path: "/profile/collector-help/purchase-originals", element: <ProfileCollectorHelpPurchaseOriginalsPage/> },
              { path: "/profile/collector-help/shipping-and-returns", element: <ProfileCollectorHelpShippingAndReturnsPage/> },
              { path: "/profile/collector-help/support-subscriptions", element: <ProfileCollectorHelpSupportSubscriptionsPage/> },
            ]
          },
          /* allow galleries + artists to add posts/articles */
          {
            element: <TypeOfAccountRequired allowedTypes={["gallery","artist"]}/>,
            children: [
              { path: "/profile/add-article", element: <AddArticle/> },
              { path: "/profile/add-article/preview", element: <ArticlePreview/> },
              { path: "/profile/edit-article/:articleId", element: <EditArticle/> }
            ]
          },
          {
            element: <PostCreatorAccessRequired />,
            children: [
              { path: "/profile/add-post", element: <AddPost/> },
              { path: "/profile/edit-post/:postId", element: <EditPost/> }
            ]
          },

          {
            element: <TypeOfAccountRequired allowedTypes={["gallery", "artist"]}/>,
            children: [
              { path: "/profile/edit-artwork", element: <EditArtwork/> },
            ]
          },
          {
            element: <TypeOfAccountRequired allowedTypes={["artist", "collector"]}/>,
            children: [
              { path: "/profile/my-collection", element: <MyCollection /> }
            ]
          },
          {
            element: <TypeOfAccountRequired allowedTypes={["collector"]}/>,
            children: [
              { path: "/profile/offers", element: <ProfileOffers /> }
            ]
          },
          {
            element: <TypeOfAccountRequired allowedTypes={["artist", "collector", "gallery"]}/>,
            children: [
              { path: "/profile/suarte-road", element: <SuarteRoad /> },
              { path: "/reward", element: <SuarteRoadReward /> }
            ]
          },
        ]
      }
    ]
  }
];

export default AppRoutes;
